import React from 'react';
import { Box, Typography } from '@mui/material';
import { styled } from '@mui/material/styles';
import { Prev, Next } from '../../assets/images';

const DateHeaderContainer = styled(Box)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '10px',
    width: '100%',
}));

const DateText = styled(Typography)(({ theme }) => ({
    fontSize: '16px',
    color: theme.palette.figma.white[80],
    fontWeight: 500,
    letterSpacing: '-0.48px',
}));

const NavigationButton = styled(Box)(({ theme }) => ({
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '4px',
    borderRadius: '4px',
    transition: 'background-color 0.2s ease',
    '&:hover': {
        backgroundColor: theme.palette.figma.white[20],
    }
}));

const DateIndicator = ({
    title = '',
    activeView = 'week', // week, month, year
    onPreviousWeek = () => { },
    onPreviousMonth = () => { },
    onPreviousYear = () => { },
    onNextWeek = () => { },
    onNextMonth = () => { },
    onNextYear = () => { },
    ...props
}) => {
    const handlePreviousClick = () => {
        if (activeView === 'year') {
            onPreviousYear();
        } else if (activeView === 'month') {
            onPreviousMonth();
        } else {
            onPreviousWeek();
        }
    };

    const handleNextClick = () => {
        if (activeView === 'year') {
            onNextYear();
        } else if (activeView === 'month') {
            onNextMonth();
        } else {
            onNextWeek();
        }
    };

    return (
        <DateHeaderContainer {...props}>
            <NavigationButton onClick={handlePreviousClick}>
                <Prev />
            </NavigationButton>
            <DateText>{title}</DateText>
            <NavigationButton onClick={handleNextClick}>
                <Next />
            </NavigationButton>
        </DateHeaderContainer>
    );
};

export default DateIndicator;
